export const getModifiers = store => store.modifiers
